import React, { useState } from "react";
import { useDispatch } from "react-redux";
import { toast } from "react-toastify";
import classNames from "classnames";
import {
    clearLocalOffers,
    loadCompareOffersFromLocalStorage,
    useMergeOffersComparisonMutation
} from "@entities/compare";
import { isFetchBaseQueryError } from "@shared/api/isFetchBaseQueryError";
import { RefreshIcon } from "@shared/ui/Icon/ui/Common/RefreshIcon";
import { MergeCompareMessages, MESSAGE_AUTO_CLOSE } from "./constants";
import classes from "./merge-compare.module.scss";

export const MergeCompare = () => {
    const dispatch = useDispatch();
    const [mergeOffers, { isLoading }] = useMergeOffersComparisonMutation();
    const [isAnimating, setIsAnimating] = useState(false);

    const handleMerge = async () => {
        setIsAnimating(true);
        const localOffers = loadCompareOffersFromLocalStorage();

        try {
            await mergeOffers({ offerUuids: localOffers, isRewrite: false }).unwrap();
            dispatch(clearLocalOffers());
            toast.success(MergeCompareMessages.MERGE_SUCCESS, { autoClose: MESSAGE_AUTO_CLOSE });
        } catch (error) {
            if (isFetchBaseQueryError(error) && error.status === 409) {
                toast.error(MergeCompareMessages.LIMIT_EXCEEDED, { autoClose: MESSAGE_AUTO_CLOSE });
            } else {
                toast.error(MergeCompareMessages.MERGE_ERROR, { autoClose: MESSAGE_AUTO_CLOSE });
            }
        } finally {
            setTimeout(() => setIsAnimating(false), MESSAGE_AUTO_CLOSE);
        }
    };

    return (
        <button className={classes["merge-compare"]} onClick={handleMerge} disabled={isLoading}>
            <RefreshIcon
                className={classNames(classes["merge-compare__icon"], {
                    [classes["merge-compare__icon--rotate"]]: isAnimating
                })}
            />
            {MergeCompareMessages.BUTTON_TEXT}
        </button>
    );
};